module["exports"] = [
  "Արագածոտն",
  "Արարատ",
  "Արմավիր",
  "Գեղարքունիք",
  "Կոտայք",
  "Լոռի",
  "Շիրակ",
  "Սյունիք",
  "Տավուշ",
  "Վայոց ձոր",
  "Երևան",
  "Ստեփանակերտ",
  "Ասկերան",
  "Հադրութ",
  "Մարտակերտ",
  "Մարտունի",
  "Շահումյան",
  "Շուշի",
  "Քաշաթաղ"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/hy/address/state.js
// module id = 3051
// module chunks = 1610